/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.LogisticsTariffThresholdResponseDto>
>;
export function request(
  params: API.tms.logisticsTariffThreshold.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsTariffThreshold/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
